import React from "react";
import { Redirect } from "react-router-dom";
import { getKey, getUserMetadata } from "../utils/localStorage";
import { log } from "console";

export const withAuth = (userType: number = -1) => (WrappedComponent) => (props) => {
  const { history } = props;
  const token = getKey("token");
  if (!token) {
    history.push("/login");
    return null;
  }

  const {
    exp,
    typ,
  } = getUserMetadata(token);

  if (typ !== 10) {
    if (typ !== userType) {
      return <Redirect to="/error" />;
    }
  }

  const validDate = new Date(exp * 1000);

  if (validDate < new Date()) {
    return <Redirect to="/login" />;
  }

  return <WrappedComponent {...props} />;
};
